import React, { ComponentType, useState } from "react"
import { compose } from "@reduxjs/toolkit"
import { useTranslation } from "react-i18next"
import { Container } from "@mui/material"

import { useAppDispatch } from "redux/hooks"
import { withCookieConsent } from "hocs/cookie"
import { updateCookie } from "redux/features/cookie/cookieConsentSlice"
import LanguageSwitcher from "components/Layout/LanguageSwitcher"
import Sheet from "components/ui/Sheet"
import Form from "components/Layout/CookieConsent/Form"
import {
  Content,
  Header,
  Title,
  Description,
  Toggle,
  Accept,
} from "components/Layout/CookieConsent/elements"
import { CookieConsentType, CookieConsentValues } from "types"

type Props = {
  cookie: CookieConsentType
}

const CookieConsentComponent = ({ cookie }: Props) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const [isForm, toggle] = useState(false)
  const isOpen = !cookie?.given

  const handleSubmit = (values: CookieConsentValues) => {
    dispatch(updateCookie(values))
  }

  const handleToggle = () => {
    toggle(true)
  }

  const handleAccept = () => {
    const values = { required: true, analytics: true, personal: true }
    dispatch(updateCookie(values))
  }

  const renderText = () => {
    const label = t("features.cookie.description.text", {
      link: `<a href=${t(
        "features.cookie.description.link.url",
      )} target="_blank">${t("features.cookie.description.link.title")}</a>`,
    })

    return <span dangerouslySetInnerHTML={{ __html: label }} />
  }

  return (
    <Sheet open={isOpen}>
      <Container>
        <Header>
          <Title>{t("features.cookie.title")}</Title>
          <LanguageSwitcher signedIn={false} />
        </Header>
        {isForm ? (
          <Form initialValues={cookie} onSubmit={handleSubmit} />
        ) : (
          <>
            <Description>{renderText()}</Description>
            <Content>
              <Accept onClick={handleAccept}>
                {t("features.cookie.accept.title")}
              </Accept>
              <Toggle onClick={handleToggle}>
                {t("features.cookie.customize.title")}
              </Toggle>
            </Content>
          </>
        )}
      </Container>
    </Sheet>
  )
}

export default compose<ComponentType>(withCookieConsent)(CookieConsentComponent)
